import { firestoreAction } from "vuexfire";
import { 
  dbGeneralRef,
  dbInterventionalRef,
  dbEpRef,
  dbAdvImgRef,
  dbAdvHfRef,
  dbAlgorithmRef,
  dbNonCardsRef,
  dbOthersRef,
  dbAboutRef,
  dbHomeRef,
  dbCccRef,
  dbAdvocacyRef,
  dbTeamRef,
} from "../../firebase";


const state = {
  generalContent: [],
  interventionalContent: [],
  epContent:[],
  advImgContent:[],
  advHfContent:[],
  algorithmContent:[],
  nonCardsContent:[],
  othersContent:[],
  aboutContent:[],
  homeContent:[],
  cccContent:[],
  teamContent:[],
  advocacyContent:[],
};

const getters = {
  getGeneralContent: (state) => state.generalContent,
  getInterventionalContent: (state) => state.interventionalContent,
  getEpContent: (state) => state.epContent,
  getAdvImgContent: (state) => state.advImgContent,
  getAdvHfContent: (state) => state.advHfContent,
  getAlgorithmContent: (state) => state.algorithmContent,
  getNonCardsContent: (state) => state.nonCardsContent,
  getOthersContent: (state) => state.othersContent,
  getAboutContent: (state) => state.aboutContent,
  getHomeContent: (state) => state.homeContent,
  getCccContent: (state) => state.cccContent,
  getAdvocacyContent: (state) => state.advocacyContent,
  getTeamContent: (state) => state.teamContent,
};

const mutations = {};

const actions = {
  setGeneralRef: firestoreAction((context) => {
    return context.bindFirestoreRef("generalContent", dbGeneralRef);
  }),

  setInterventionalRef: firestoreAction((context) => {
    return context.bindFirestoreRef(
      "interventionalContent",
      dbInterventionalRef
    );
  }),

  setEpRef: firestoreAction((context) => {
    return context.bindFirestoreRef("epContent", dbEpRef);
  }),

  setAdvImgRef: firestoreAction((context) => {
    return context.bindFirestoreRef("advImgContent", dbAdvImgRef);
  }),

  setAdvHfRef: firestoreAction((context) => {
    return context.bindFirestoreRef("advHfContent", dbAdvHfRef);
  }),

  setAlgorithmRef: firestoreAction((context) => {
    return context.bindFirestoreRef("algorithmContent", dbAlgorithmRef);
  }),

  setNonCardsRef: firestoreAction((context) => {
    return context.bindFirestoreRef("nonCardsContent", dbNonCardsRef);
  }),

  setOthersRef: firestoreAction((context) => {
    return context.bindFirestoreRef("othersContent", dbOthersRef);
  }),

  setAboutRef: firestoreAction((context) => {
    return context.bindFirestoreRef("aboutContent", dbAboutRef);
  }),

  setHomeRef: firestoreAction((context) => {
    return context.bindFirestoreRef("homeContent", dbHomeRef);
  }),

  setCccRef: firestoreAction((context) => {
    return context.bindFirestoreRef("cccContent", dbCccRef);
  }),

  setTeamRef: firestoreAction((context) => {
    return context.bindFirestoreRef("teamContent", dbTeamRef);
  }),

  setAdvocacyRef: firestoreAction((context) => {
    return context.bindFirestoreRef("advocacyContent", dbAdvocacyRef);
  }),

};

export default {
  state,
  mutations,
  getters,
  actions,
  
};
